import React from "react";
import { cn } from "../../lib/utils";

export const Button = ({
  children,
  isActive = false,
  className,
  disabled = false,
  langMode: _langMode,
  ...props
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={isActive}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-md border px-4",
        "min-h-[36px] h-9 py-0 text-sm font-medium whitespace-nowrap",
        "transition-all duration-200 ease-in-out",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#236DB4]/50 focus-visible:ring-offset-2",
        "dark:focus-visible:ring-offset-gray-900",
        isActive
          ? [
            "border-[#1d5a96] bg-[#236DB4] text-white shadow-md",
            "hover:bg-[#1d5a96] active:bg-[#184a7d]",
            "dark:border-[#1d5a96] dark:bg-[#236DB4] dark:hover:bg-[#1d5a96]",
          ]
          : [
            "border-gray-200/80 bg-white text-gray-600 shadow-sm",
            "hover:border-gray-300 hover:bg-gray-50 hover:text-gray-900",
            "dark:border-gray-600/50 dark:bg-gray-700 dark:text-gray-300",
            "dark:hover:border-gray-500 dark:hover:bg-gray-600 dark:hover:text-gray-100",
          ],
        disabled && "pointer-events-none cursor-not-allowed opacity-50",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};
